import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

function CloseButton({ onClose, ...props }) {
  return (
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={{
        color: theme => theme.palette.grey[500],
        marginTop: -1,
      }}
      {...props}>
      <CloseIcon />
    </IconButton>
  );
}
export default CloseButton;
